<template>
  <w-modal
    v-model="show"
    close-button="Anuluj"
    submit-button="Dodaj"
    :close-on-submit="false"
    :hide-on-overlay="false"
    :hide-on-esc="false"
    @submit="save"
    @close="close"
  >
    <div class="row">
      <w-input
        class="form-group col-md-12"
        :model="$schema.uid"
        @input="loadDocumentName($schema.uid.$model, 'mdok/getDocumentNameAndData')"
      />

      <div v-if="documentName && $schema.uid.$model" class="form-group col-md-12">
        <p>
          Wybrano dokument: <b>{{ documentName }}</b>
        </p>
      </div>

      <div v-if="showAddidtionalFields" class="col-md-12 row">
        <w-select class="form-group col-md-12" :model="$schema.documentValues.numberCode" :values="numberCodes" />

        <w-input class="form-group col-md-12" :model="$schema.documentValues.number" />

        <w-select class="form-group col-md-12" :model="$schema.documentValues.dateCode" :values="dateCodes" />

        <w-datepicker class="form-group col-md-12" :model="$schema.documentValues.date" />
      </div>
    </div>
  </w-modal>
</template>

<script>
import { mapState } from 'vuex';

import { DocumentValueCodesTranslations } from '@/enums/documentValueCodes.enum';
import { Errors } from '@/enums/errors.enum';
import { PublicSettings } from '@/enums/publicSettings.enum';
import { manageMixin } from '@/mixins/manage';
import { mdokDocumentMixin } from '@/mixins/mdokDocument';
import schema from '@/schemas/addFromMdok.schema';

const emptyData = () => ({ uid: null });

// @vuese
// Modal dodawania dokumentów z Mdok
// @group Modals
export default {
  mixins: [mdokDocumentMixin, manageMixin(undefined, {}, emptyData)],
  schema,
  data() {
    return {
      dateCodes: this.documentValueSelectOptions('DATE'),
      numberCodes: this.documentValueSelectOptions('NUMBER')
    };
  },
  computed: mapState({
    showAddidtionalFields(state) {
      return state.setting.settings[PublicSettings.DISABLE_MDOK_IMPORT_EXTRA_FIELDS]?.value !== 'true';
    }
  }),
  methods: {
    // @vuese
    // Waliduje formularz i emituje event do zapisu danych
    save() {
      if (!this.$schema.$validateAll().length) {
        const model = this.prepareModel(this.$schema.$getData());
        this.$emit('save', model);
      } else {
        this.notifyError(Errors.FORM_INCORRECTLY_COMPLETED);
      }
    },

    // @vuese
    // Wczytuje numer i datę dostarczenia dokumentu do schemy
    afterNameGet(data) {
      if (data.data) {
        this.$schema.documentValues.number.$setData(data.data.number);
        this.$schema.documentValues.date.$setData(data.data.incomeDate);
      }
    },

    // @vuese
    // Zwraca odfiltrowaną listę wartości systemowych do selecta
    documentValueSelectOptions(type) {
      return Object.keys(DocumentValueCodesTranslations)
        .filter(code => code.includes(type))
        .map(value => ({ value, text: DocumentValueCodesTranslations[value] }));
    }
  }
};
</script>
